import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoney16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoney16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 1.5A.5.5 0 0 1 8 2v.728c.944.058 1.614.4 2.058.761.24.196.411.392.524.544a2 2 0 0 1 .161.25l.01.02.005.006.001.003v.002l-.447.222.448-.221a.5.5 0 0 1-.894.447l-.002-.003-.013-.022a2 2 0 0 0-.423-.47c-.324-.264-.864-.548-1.714-.548q-.59.002-1.03.092l-1.505-.45c.48-.34 1.102-.534 1.821-.607V2a.5.5 0 0 1 .5-.5m-.817 2.31 3.18.949.002.001zM8 13.254c.678-.047 1.384-.266 1.954-.705.668-.515 1.116-1.31 1.116-2.383 0-.899-.517-1.488-1.153-1.89-.585-.37-1.341-.627-2.03-.862l-.1-.033c-.75-.256-1.418-.493-1.905-.82-.46-.311-.699-.661-.699-1.158 0-.579.207-.964.575-1.225.226-.16.532-.287.925-.366L5.18 3.36c-.662.47-.996 1.177-.996 2.041 0 .928.497 1.553 1.14 1.986.618.416 1.42.692 2.142.938l.039.013c.74.253 1.396.476 1.879.78.467.296.687.612.687 1.046 0 .762-.304 1.266-.726 1.591-.44.339-1.039.507-1.63.507-.973 0-1.805-.388-2.407-.796a5.6 5.6 0 0 1-.874-.734l-.043-.046-.009-.01v-.001l-.36.306.36-.306a.5.5 0 0 0-.762.648L4 11l-.38.324v.001l.002.003.005.006.017.019.06.065q.078.084.222.221c.19.18.468.418.82.657.562.38 1.332.772 2.254.912V14a.5.5 0 0 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoney16);
